import { API } from '@aws-amplify/api';

interface SetUserStatusInput {
  email: string;
  enabled: boolean;
}

interface SetUserStatusResponse {
  email: string;
  enabled: boolean;
  /** How many Cognito records were changed — a staff member usually has a local
   *  record plus one or more federated Google records. */
  affected: number;
}

export async function setUserStatus(input: SetUserStatusInput): Promise<SetUserStatusResponse> {
  try {
    const apiName = process.env.NEXT_PUBLIC_DASH_API_NAME!;
    const path = 'set-user-status';
    const myInit = {
      queryStringParameters: {},
      body: input,
    };

    return await API.post(apiName, path, myInit);
  } catch (error) {
    console.error(error);
    throw error;
  }
}
